import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
} from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { Header } from './shared/components/header/header';
import {
  BrFooter,
  BrFooterLegal,
} from '@govbr-ds/webcomponents-angular/standalone';
import { provideFlatpickrDefaults } from 'angularx-flatpickr';
import { DatePickerConf } from './core/config/date-picker.conf';

import { GlobalMessageComponent } from './shared/components/global-message/global-message.component';
import { FormsModule } from '@angular/forms';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { Title } from './shared/components/title/title';
import { filter } from 'rxjs';
import { CommonModule } from '@angular/common';
import { SimulationBannerComponent } from './shared/components/simulation-banner/simulation-banner.component';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    Header,
    Title,
    BrFooter,
    BrFooterLegal,
    GlobalMessageComponent,
    FormsModule,
    LoadingComponent,
    CommonModule,
    SimulationBannerComponent,
  ],
  providers: [provideFlatpickrDefaults(new DatePickerConf())],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements AfterViewInit {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  title = 'Plataforma de Gerenciamento de Programas de Provimento - PGP';

  crumbs: { label: string; url?: string; active?: boolean }[] = [];
  showHeader = true;
  showFooter = true;

  ngAfterViewInit(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        let currentRoute = this.activatedRoute;
        while (currentRoute.firstChild) {
          currentRoute = currentRoute.firstChild;
        }

        if (currentRoute.snapshot.data['breadcrumb']) {
          this.crumbs = (
            currentRoute.snapshot.data['breadcrumb'] as {
              label: string;
              url?: string;
              active?: boolean;
            }[]
          ).map((breadcrumb, index) => {
            breadcrumb.active =
              currentRoute.snapshot.data['breadcrumb'].length - 1 == index;
            return breadcrumb;
          });
        } else {
          this.crumbs = [];
        }
        const path = currentRoute.snapshot.routeConfig?.path;
        if (path === 'login' || path === 'ouvidoria') {
          this.showHeader = false;
          this.showFooter = false;
        } else {
          this.showHeader = true;
          this.showFooter = true;
        }
      });
  }
}
